import { render, staticRenderFns } from "./DictionaryList.vue?vue&type=template&id=a746bb10&scoped=true&"
import script from "./DictionaryList.vue?vue&type=script&lang=js&"
export * from "./DictionaryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a746bb10",
  null
  
)

export default component.exports